
import React from 'react'; // live

// import { StrictMode } from 'react'; // dev

import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './state/store';
import { Provider } from 'react-redux';
import { BrowserRouter, useLocation } from 'react-router-dom';

const AppWrapper = () => {
    const location = useLocation();
    return <App location={location} />;
};

// Google Analytics Script
if (process.env.REACT_APP_GA_ID) {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_ID}`;
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", `${process.env.REACT_APP_GA_ID}`);
  };
  document.head.appendChild(script);
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	
	// remove the StrictMode tag when going live - Becaue it checks bugs in development and run everything twice
	// <StrictMode>
    <Provider store={store}>
        <BrowserRouter>
            <AppWrapper />
        </BrowserRouter>
    </Provider>
	// </StrictMode>
  
  /*
  <React.StrictMode>
   <Provider store = {store}>
        <App />
    </Provider>,
  </React.StrictMode>
  */
);
